import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

/** Red "Remove" link-style button, shared by process cards and input material cards. */
const RemoveButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Button
        text
        label={t('footprintDetailsPage.sections.calculatePcfSection.buttons.remove')}
        className='hover:underline p-button-danger p-0'
        size='small'
        onClick={() => {
          onClick();
        }}
      />
    </div>
  );
};

export default RemoveButton;
